export type Phone = {
    entityId: string;
    value: {
        value: string;
        valueRaw: string;
    };
};

export type CreatorOriginCategoryValue = {
    category: CreatorOriginCategory;
    threadUrl: string | null;
    threadId?: string | null;
    submissionId?: string | null;
    activityId?: string | null;
};

export const CREATOR_ORIGIN_CATEGORY_LABELS = {
    chat_thread: 'Chat',
    engagement_booking: 'Booking',
    engagement_text: 'Text',
    engagement_call: 'Call',
    engagement_quote: 'Quote',
    engagement_email: 'Email',
    chat_offline: 'Chat',
    chatbot: 'Chatbot',
} as const;

export type CreatorOriginCategory = keyof typeof CREATOR_ORIGIN_CATEGORY_LABELS;

/**
 * Display names for creator origin category. The set comes from
 * fields_lead.json (creatorOriginCategory.enum); we also include 'Chat' and
 * 'Chatbot' for mapping legacy/alternate display values.
 */
export type CreatorOriginDisplayName =
    | 'Chat thread'
    | 'Quote'
    | 'Booking'
    | 'Email'
    | 'Text'
    | 'Call'
    | 'Chat'
    | 'Chatbot';

export const CREATOR_ORIGIN_CATEGORY_DISPLAY_NAME_TO_KEY: Record<
    CreatorOriginDisplayName,
    CreatorOriginCategory
> = {
    'Chat thread': 'chat_thread',
    Quote: 'engagement_quote',
    Booking: 'engagement_booking',
    Email: 'engagement_email',
    Text: 'engagement_text',
    Call: 'engagement_call',
    Chat: 'chat_offline',
    Chatbot: 'chatbot',
};
